/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as amplitude from '@amplitude/analytics-browser';

export const START_CONTAINER_TRIAL = () => amplitude.track('Start Container Trial');
export const START_DE_TRIAL = () => amplitude.track('Start DE Trial');
export const START_SE_TRIAL = () => amplitude.track('Start SE Trial');

// Tracks when user opens 'Add payment method' modal
// If user has no card registered, `first` prop is true, otherwise is false
export const ATTEMPT_ADD_CREDIT_CARD = ({ first }: { first: boolean }) => {
  amplitude.track('Attempt Add Credit Card', { first });
};

// Tracks when user successfully adds credit card in 'Add payment method' modal
// If user has no card registered, `first` prop is true, otherwise is false
export const ADD_CREDIT_CARD = ({ first }: { first: boolean }) =>
  amplitude.track('Add Credit Card', { first });
